/**
 * Interface for holiday requests
 */

import { Comment } from '../comments/Comment.types';

export interface Holiday {
  id: string;
  createDate: Date;
  decidedBy?: string;
  decisionDate?: Date;
  userId: string;
  deputyId: string;
  startDate: Date;
  endDate: Date;
  totalAmount: number;
  officeId: string;
  approved: boolean;
  denied: boolean;
  requestComment?: Comment;
  decisionComment?: Comment;
  reasonId?: string;
  changes: HolidayChangeHistory[];
  onlyOn?: DayPart;
}
/**
 * Used to split holidays for half days
 */
export enum DayPart {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
}

/**
 * Stores the old informations if an holidayRequest is adjusted
 */
export interface HolidayChangeHistory {
  oldStart: Date;
  oldEnd: Date;
  oldAmount: number;
  oldReasonId: string;
  comment: string;
  changedBy: string;
  createDate: Date;
}

/**
 * Possible states for a holidayRequest
 */
export enum HolidayState {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
}
